const colors = {
  borda: '#e1e1e1',
  primary: '#0D364A',
  primaryShade: '#01141b',
  blue: '#001F2A',
  branco: '#fff',
  verde: '#24A95D',
  vermelho: '#A61F1F',
  vermelhoBerry: '#D42929',
  cinza: '#abb9c0',
  greyText: '#707070',
  lightGrey: '#E0E0E0',
  amarelo: '#FFCA29',
  gbGrey: '#F2F2F2',
  blackText: '#3E3E3E',

  status: {
    verde: '#24b314',
    vermelho: '#c21a1a',
    amarelo: '#f8bc34',
    laranja: '#f88e34',
    padrao: '#b1b1b1',
  },
};

export default colors;
